module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "margin",
    class: _vm.size
  }, [_c('strong', {
    staticClass: "ds-block"
  }, [_vm._v(_vm._s(_vm.$t('price.type.label')))]), _vm._v("\n    " + _vm._s(_vm.$t(((_vm.price.type) + ".label"))) + "\n  ")]), _vm._v(" "), (_vm.price.auxiliary !== 0) ? _c('div', {
    staticClass: "margin",
    class: _vm.size
  }, [_c('strong', {
    staticClass: "ds-block"
  }, [_vm._v(_vm._s(_vm.$t(("price." + (_vm.price.type) + ".auxiliary.label"))))]), _vm._v(" "), (_vm.price.type === 'fixedValue') ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.price.auxiliary)))]) : _c('span', [_vm._v(_vm._s(((_vm.price.auxiliary) + " %")))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin",
    class: _vm.size
  }, [_c('strong', {
    staticClass: "ds-block"
  }, [_vm._v(_vm._s(_vm.$t('price.previous.label')))]), _vm._v("\n    " + _vm._s(_vm._f("currency")(_vm.price.previous)) + "\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.size
  }, [_c('strong', {
    staticClass: "ds-block"
  }, [_vm._v(_vm._s(_vm.$t('price.current.label')))]), _vm._v("\n    " + _vm._s(_vm._f("currency")(_vm.price.current)) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e35b8236","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shared/Price.vue
// module id = 3462
// module chunks = 0